/**
 * form の値を送信用の値に変換する
 */
export const getHotlineClientRequestReorderSubmitValues = (formValue) => ({
    condition: formValue.condition,
    description: formValue.description,
    schedule_1: formValue.schedule1,
    schedule_2: formValue.schedule2,
    schedule_3: formValue.schedule3,
});
